import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axios from "axios";

import { ReactComponent as ArrowRight } from "../../../assets/icons/svg/arrow-right.svg";
import Input from "../../reusable/Input/Input";
import Button from "../../reusable/Button/Button";
import "./PersonalDataForm.scss";
import moment from "moment";
import _ from "lodash";
import 'moment/locale/ro';
import { calculateFee, isEmailValid } from "../../../utils/functions";

const PersonalDataForm = (props) => {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");

    const [teams, setTeams] = useState([]);
    const [team, setTeam] = useState(null);

    const [players, setPlayers] = useState([]);
    const [child, setChild] = useState(null);

    const [paymentTypes, setPaymentTypes] = useState([]);
    const [paymentType, setPaymentType] = useState(null);

    const [paymentAmount, setPaymentAmount] = useState("");
    const [penalty, setPenalty] = useState(null);

    const [monthsToPay, setMonthsToPay] = useState([]);
    const [monthToPay, setMonthToPay] = useState(null);

    const [checkbox, setCheckbox] = useState(false);

    const [message, setMessage] = useState("");

    const [error, setError] = useState("");

    const [styleFocused1, setStyleFocused1] = useState({ 'borderBottom': `1px solid grey` });
    const [styleFocused2, setStyleFocused2] = useState({ 'borderBottom': `1px solid grey` });
    const [styleFocused3, setStyleFocused3] = useState({ 'borderBottom': `1px solid grey` });

    const [fees, setFees] = useState(null);

    useEffect(() => {
        getTeams(); //get teams for select
    }, []);

    const getTeams = () => {
        axios.get(`site/get_teams_for_payments?id_club=${props.id_club}`)
            .then(res => {
                const teams = [...res.data].map(elem => ({ "label": elem.team_name, "value": elem.id_team }))
                setTeams(teams);
            })
            .catch(err => console.log(err));

    }

    const getPlayers = (team) => {
        if (team?.value) {
            axios.get(`site/get_players_payments_site_3?id_club=${props.id_club}&id_team=${team.value}`)
                .then(res => {
                    if (res.data.success == 1) {
                        const players = [...res.data.list].map(elem => ({ ...elem, "label": elem.label.toUpperCase(), }))
                        setPlayers(players);
                        setFees({
                            club_fee: res.data.club_fee,
                            stripe_fee_percent: res.data.stripe_fee_percent,
                            stripe_fee_units: res.data.stripe_fee_units,
                            currency_label: res.data.currency_label,
                            minimum_charge_amount: res.data.minimum_charge_amount,
                        });
                    } else {
                        setPlayers([]);
                    }
                })
                .catch(err => console.log(err));
        }
    }

    const setMonthsForSelect = () => {
        let previousMonthYear = moment().add(-6, 'M').startOf('month').locale("ro");
        let nextMonthYear = moment().add(6, 'M').startOf('month').locale("ro");

        let monthsSelect = [];

        if (previousMonthYear < nextMonthYear) {
            let date = previousMonthYear;

            while (date < nextMonthYear) {
                const year = date.format("YYYY");
                const month = date.format("M");
                const isPaid = (child?.payments?.[year]?.list?.[month]?.payment_amount ?? 0) != 0;

                monthsSelect.push({
                    label: _.capitalize(date.format("MMMM YYYY")),
                    value: date.format("M-YYYY"),
                    month: date.format("M"),
                    year: date.format("YYYY"),
                    isDisabled: isPaid,
                });
                date.add(1, 'month');
            }
        }

        setMonthsToPay(monthsSelect);
    }

    const nextStep = (e) => {
        e.preventDefault();
        if (
            name != "" &&
            email != "" &&
            team != null &&
            child != null &&
            paymentType != null &&
            Number(paymentAmount) >= fees?.minimum_charge_amount &&
            (paymentType?.type == "monthly" ? monthToPay != null : true)
        ) {
            if (isEmailValid(email)) {
                props.dataAuth({
                    name: name,
                    email: email,
                    id_team: team,
                    id_child: child?.value,
                    payment_type: paymentType?.type,
                    payment_type_obj: paymentType,
                    payment_amount: paymentAmount,
                    recurrent_payment: checkbox,
                    description: message,
                    payment_month: monthToPay?.month ?? "",
                    payment_year: monthToPay?.year ?? "",
                });
            } else {
                setError("Email-ul nu este valid.");
            }
        } else {
            if (Number(paymentAmount) < fees?.minimum_charge_amount) {
                setError(`Suma minimă este de ${fees.minimum_charge_amount} ${fees.currency_label}.`);
            } else {
                setError("Toate câmpurile sunt obligatorii.");
            }
        }
    }

    return (
        <div className="personal-data-form-container" style={{ display: props.toShow ? "block" : "none", color: props.config_options.contact_color }}>
            <div className="personal-data-form-title">
                {"Pas 1 din 2"}
            </div>
            <div className="personal-data-form-content">
                <form>
                    <div className="form-row">
                        <Input
                            style={styleFocused1}
                            name="name"
                            label="Nume și prenume"
                            value={name}
                            handleChange={(e) => {
                                setName(e.target.value);
                                setError("");
                            }}
                            onFocus={() => {
                                setError("");
                                setStyleFocused1({ 'borderBottom': `1px solid ${props.config_options.buttons_color}` });
                            }}
                            onBlur={() => {
                                setStyleFocused1({ 'borderBottom': `1px solid grey` });
                            }}
                            halfWidth
                        />
                        <Input
                            style={styleFocused2}
                            name="email"
                            label="Email"
                            value={email}
                            handleChange={(e) => {
                                setEmail(e.target.value);
                                setError("");
                            }}
                            onFocus={() => {
                                setError("");
                                setStyleFocused2({ 'borderBottom': `1px solid ${props.config_options.buttons_color}` });
                            }}
                            onBlur={() => {
                                setStyleFocused2({ 'borderBottom': `1px solid grey` });
                            }}
                            halfWidth
                        />
                    </div>
                    <div className="form-row custom-form-row">
                        <div className="group half-width">
                            <div className="select">
                                <label className="child-input-label" style={{ paddingLeft: "5px" }}>{"Echipă"}</label>
                                <Select
                                    className="input-select"
                                    name="echipa"
                                    label="Echipă"
                                    placeholder={"Selectează..."}
                                    value={team}
                                    options={teams}
                                    onChange={(item) => {
                                        setError("");
                                        setTeam(item);
                                        getPlayers(item);
                                        setChild(null);
                                        setPaymentTypes([]);
                                        setPaymentType(null);
                                        setPaymentAmount('');
                                        setCheckbox(false);
                                        setMonthToPay(null);
                                        setMessage("");
                                        setMonthsToPay([]);
                                        setPenalty(null);
                                    }}
                                    onFocus={() => setError("")}
                                    styles={{ marginBottom: "50px", width: "100%" }}
                                />
                            </div>
                        </div>
                        <div className="group half-width">
                            <div className="select">
                                <label className="child-input-label" style={{ paddingLeft: "5px" }}>{"Copil"}</label>
                                <Select
                                    className="input-select"
                                    name="child"
                                    label="Copil"
                                    placeholder={"Selectează..."}
                                    value={child}
                                    options={players}
                                    onChange={(item) => {
                                        setError("");
                                        setChild(item);
                                        setPaymentTypes(item?.payment_types);
                                        setPaymentType(null);
                                        setPaymentAmount('');
                                        setCheckbox(false);
                                        setMonthToPay(null);
                                        setMessage("");
                                        setMonthsToPay([]);
                                        setPenalty(null);
                                    }}
                                    onFocus={() => setError("")}
                                    styles={{ marginBottom: "50px", width: "100%" }}
                                    isDisabled={!team}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div
                            className="group no-margin-bottom half-width"
                            style={{ display: "flex", gap: "25px" }}
                        >
                            <div className="select">
                                <label className="child-input-label" style={{ paddingLeft: "5px" }}>{"Tip plată"}</label>
                                <Select
                                    className="input-select"
                                    name="payment"
                                    label="Tip plata"
                                    options={paymentTypes}
                                    placeholder={"Selectează..."}
                                    value={paymentType}
                                    onChange={(item) => {
                                        setError("");
                                        setPaymentType(item)
                                        if (item?.type != 'other') {
                                            setPaymentAmount(item.amount);
                                        } else {
                                            setPaymentAmount('');
                                        }
                                        if (item?.type == 'monthly') {
                                            setMonthsForSelect();
                                        }
                                        setCheckbox(false);
                                        setMonthToPay(null);
                                        setMessage("");
                                        setPenalty(null);
                                    }}
                                    onFocus={() => setError("")}
                                    styles={{ marginBottom: "50px", width: "100%" }}
                                    isDisabled={!child}
                                />
                            </div>
                            {paymentType?.value && (
                                <div className="quarter-width align-corner-left">
                                    <label className="child-input-label">{"Sumă"}</label>
                                    <input
                                        className="form-input"
                                        disabled={(props.editableMonthlyTax == 0 && paymentType?.value != "other") || penalty > 0}
                                        value={paymentAmount}
                                        onChange={(event) => {
                                            setPaymentAmount(event.target.value);
                                        }}
                                        onFocus={() => {
                                            setError("");
                                            setStyleFocused3({ 'borderBottom': `1px solid ${props.config_options.buttons_color}` });
                                        }}
                                        onBlur={() => {
                                            setStyleFocused3({ 'borderBottom': `1px solid grey` });
                                        }}
                                        style={styleFocused3}
                                    />
                                    <label className="child-input-label">{fees.currency_label}</label>
                                </div>
                            )}
                        </div>
                        {paymentType?.value == "monthly" &&
                            <div className="group no-margin-bottom half-width">
                                <div className="select">
                                    <label className="child-input-label" style={{ paddingLeft: "5px" }}>{"Lună plată"}</label>
                                    <Select
                                        className="input-select"
                                        name="payment"
                                        label="Lună plată"
                                        placeholder={"Selectează..."}
                                        value={monthToPay}
                                        options={monthsToPay}
                                        onChange={(item) => {
                                            setMonthToPay(item)
                                            setError("");
                                            setPenalty(null);
                                            if (paymentType?.value == "monthly") {
                                                let amount = child?.amount ?? 0;
                                                const condition = child?.conditions?.[item.year]?.list?.[item.month] ?? null;
                                                if (condition) {
                                                    const penalty = condition?.penalty ? Number(condition.penalty) : 0;
                                                    amount = Number(condition.amount) + penalty;
                                                    if (penalty > 0) {
                                                        setPenalty(penalty);
                                                    }
                                                }
                                                setPaymentAmount(amount > 0 ? amount : "");
                                            }
                                        }}
                                        onFocus={() => setError("")}
                                        styles={{ marginBottom: "50px", width: "100%" }}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                    {paymentType?.value == "monthly" && penalty > 0 &&
                        <div className="form-row commision-message">
                            <div>
                                {"Detalii:"}
                                <ul style={{ marginBottom: 0 }}>
                                    <li>{`Taxă - ${paymentAmount - penalty} ${fees.currency_label}`}</li>
                                    <li>{`Penalizare întârziere - ${penalty} ${fees.currency_label}`}</li>
                                </ul>
                            </div>
                        </div>
                    }
                    {Number(paymentAmount) >= fees?.minimum_charge_amount && paymentType?.value && props.feePassedToCustomer == 1 && fees &&
                        <div className="form-row commision-message">
                            {`Comisonul pentru această plată este de ${calculateFee(paymentAmount, fees.club_fee, fees.stripe_fee_percent, fees.stripe_fee_units)} ${fees.currency_label}.`}
                        </div>
                    }
                    {(paymentType?.value == "other") &&
                        <div className="form-row custom-form-row half-width top-margin">
                            <Input
                                label="Descriere"
                                value={message}
                                onChange={(event) => {
                                    setMessage(event.target.value);
                                }}
                            />
                        </div>
                    }
                    {error !== "" && <div className="error-row">{error}</div>}
                    <div className="button-row" style={{ marginTop: "60px" }}>
                        <Button type="submit" onClick={nextStep}
                            theme={props.config_options.id_theme}
                            color={props.config_options.buttons_text_color}
                            backgroundColor={props.config_options.buttons_color}
                            disabled={name == "" ||
                                email == "" ||
                                team == null ||
                                child == null ||
                                paymentType == null ||
                                (paymentType?.type == "monthly" ? monthToPay == null : false) ||
                                (paymentType?.type == "other" ? message == "" : false)
                            }
                        >
                            {"URMĂTORUL PAS"}
                            <ArrowRight
                                fill={props.config_options.buttons_text_color}
                                className={`send-icon rigth`} />
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PersonalDataForm;
